import { render, staticRenderFns } from "./DoorGuard.vue?vue&type=template&id=4f858f6e&scoped=true"
import script from "./DoorGuard.vue?vue&type=script&lang=js"
export * from "./DoorGuard.vue?vue&type=script&lang=js"
import style0 from "./DoorGuard.vue?vue&type=style&index=0&id=4f858f6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f858f6e",
  null
  
)

export default component.exports